import React, { Fragment, useState, useEffect } from "react";
import Starter from "../../../component/Starter";
import Card from "../../../component/card/Card";
import TableHeader from "../../../component/tableHeader/TableHeader";
import { tableHeaderData } from "./data";
import TopInput from "./TopInput";
import { helperFunction } from "../../../constant/helper";
import { useDispatch, useSelector } from "react-redux";
import useSortableData from "../../../customHooks/sortingHooks";
import { hrActions } from "../../../redux/actions";
import { types } from "../../../redux/type";
import MissingList from "./MissingList";
import isEmpty from "../../../validation/isEmpty";
import axios from "axios";
import { api } from "../../../apis";
import ReactHTMLTableToExcel from "react-html-table-to-excel";

const initialState = {
  date: "",
  year: "",
  month: "",
  dataType: "",
  locationId: "",
  missingFilter: ""
};

const SingleMissingAttendance = () => {
  const loginType = localStorage.getItem("loginType");
  const dispatch = useDispatch();
  const [allMissingData, setAllMissingData] = useState([]);
  const [values, setValues] = useState(initialState);
  const [allLocations, setAllLocations] = useState([]);

  const { currentUser } = useSelector((state) => state.auth);

  const { hrResponse, hrError, hrLoading, missingAttendanceList } =
    useSelector((state) => state.hr);

  const { locationError, locations } = useSelector(
    (state) => state.location
  );

  useEffect(() => {
    if (hrError) {
      helperFunction.toastHelper("error", hrError);
    }
    if (hrResponse) {
      helperFunction.toastHelper("success", hrResponse);
    }
  }, [hrError, hrResponse]);

  useEffect(() => {
    if (locationError) {
      helperFunction.toastHelper("error", locationError);
    }
  }, [locationError]);

  useEffect(() => {
    setAllMissingData(missingAttendanceList);
  }, [missingAttendanceList]);

  useEffect(() => {
    if (locations !== null) {
      setAllLocations(locations);
    } else {
      setAllLocations([]);
    }
  }, [locations]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setValues({
      ...values,
      [name]: value
    });
  };

  const onGetMissingData = (e) => {
    e.preventDefault();
    if (values.locationId !== "") {
      const data = JSON.stringify(values);
      dispatch(hrActions.setHrLoading(true));
      dispatch(hrActions.clearHrErrors());
      dispatch(hrActions.clearHrResult());
      dispatch(
        hrActions.getAllMissingAttendanceList(data, loginType)
      );
    } else {
      const errorData = {
        data: { message: "Location Not selected" },
        status: 400
      };
      dispatch({
        type: types.HrTypes.HR_GET_ERRORS,
        payload: errorData
      });
    }
  };

  const changeSelectedStatus = async (e, missingData) => {
    try {
      e.preventDefault();
      const { value } = e.target;
      if (value !== "APPLIED") {
        const regularizedDataObject = {
          missingAttendanceId: missingData._id,
          attendedId: localStorage.getItem("id"),
          status: value
        };

        const { baseUrlPython } = await helperFunction.checkLoginType(
          loginType
        );

        const url = `${baseUrlPython}${api.Hr_Api.TAKE_ATTENDANCE_ACTION_API}`;
        const response = await axios.post(url, regularizedDataObject);

        const { data } = response;
        if (!isEmpty(data.message)) {
          helperFunction.toastHelper("success", data.message);
          setAllMissingData(
            allMissingData.map((clickUser) => {
              if (clickUser._id === missingData._id) {
                clickUser.missingAttendanceStatus = value;
              }
              return clickUser;
            })
          );
        } else {
          helperFunction.toastHelper(
            "error",
            "Not able to update status"
          );
        }
      }
    } catch (error) {
      helperFunction.toastHelper("error", error.response.data);
    }
  };

  const { items, requestSort, sortConfig } =
    useSortableData(allMissingData);

  return (
    <Starter
      topBarTitle="All Missing Attendance"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">HR Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">HR</a>
          </li>
          <li className="breadcrumb-item active">
            All Missing Attendance
          </li>
        </Fragment>
      }
    >
      <Card>
        <TopInput
          values={values}
          hrLoading={hrLoading}
          onGetMissingData={onGetMissingData}
          currentUser={currentUser}
          allLocations={allLocations}
          onChange={handleInputChange}
        />
        <div className="table-responsive">
          <table
            className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap"
            id="products-datatable"
          >
            <thead className="thead-light">
              <tr>
                <th style={{ width: "20px" }}>#</th>
                <TableHeader
                  tableHeaderData={tableHeaderData}
                  requestSort={requestSort}
                  sortConfig={sortConfig}
                />
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <MissingList
                hrLoading={hrLoading}
                changeSelectedStatus={changeSelectedStatus}
                missingListData={items}
              />
            </tbody>
          </table>
        </div>
        <div className="row mt-3">
          <div className="col-sm-1"></div>
          <div className="col-sm-4"></div>
          <div className="col-2">
            <ReactHTMLTableToExcel
              className="btn btn-dark btn-block"
              table="products-datatable"
              filename="Missing_data"
              sheet="Sheet"
              buttonText="Export excel"
            />
          </div>
          <div className="col-sm-1"></div>
          <div className="col-sm-4"></div>
        </div>
      </Card>
    </Starter>
  );
};

export default SingleMissingAttendance;
